import{styled}from"styled-components";export const Listbox=/*#__PURE__*/styled.div.withConfig({componentId:"sc-7ptivy-0"})`display:flex;flex-direction:column;gap:4px;overflow-y:auto;`;
//# sourceMappingURL=listbox.styles.js.map